import { lazy } from 'react';

export type { RateTierMapProps } from './RateTierMap';
export type { RateTier } from './defaultTiers.generated';
export { DEFAULT_TIER_ASSIGNMENTS } from './defaultTiers.generated';
export { TIER_COLORS } from './paths.generated';
export type { ElevationBand } from './elevation.generated';
export { ELEVATION_BANDS } from './elevation.generated';

/**
 * Lazy-loaded RateTierMap. ~230KB of precomputed SVG paths ship in a separate
 * chunk so they don't bloat the main bundle.
 *
 * Wrap usage in <Suspense fallback={...}>.
 */
export const RateTierMap = lazy(() =>
  import('./RateTierMap').then((m) => ({ default: m.RateTierMap })),
);
